import {GET, POST} from "@/services/gateway";

const listSnapshots = ({date, dateTo}) => {
  return POST('entra-id/snapshot/list', {date, dateTo})
}

const createBackup = (userId) => {
  return GET('entra-id/backup', {userId})
}

const exportSnapshot = ({
                          snapshotDateTime,
                          sourceIds,
                          searchTerm,
                          snapshotId,
                          selectedIds,
                          code,
                          objectType,
                        }) => {
  return POST('entra-id/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm,
    snapshotId,
    selectedIds,
    objectType,
  }, {code: code ? code : null})
}

const connectSetup = (data) => {
  return POST('entra-id/connectSetup', data)
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           searchTerm,
                           destinationType,
                           RestoreType,
                           objectType,
                           selectedIds,
                           includeMembers = false,
                           includeMemberships = false,
                           includeRoles = false,
                           includeOwners = false,
                           includeUsersAndGroups = false,
                           includeGroupOwnership = false,
                           code
                         }) => {
  return POST('entra-id/restore', {
    snapshotDateTime,
    searchTerm,
    destinationType,
    restoreType: RestoreType,
    objectType,
    selectedIds,
    includeMembers,
    includeMemberships,
    includeRoles,
    includeOwners,
    includeUsersAndGroups,
    includeGroupOwnership
  }, {code: code ? code : null});
}

const compareSnapshot = ({sourceIds, selectedIds, objectType, firstSnapshotDateTime, secondSnapshotDateTime}) => {
  let firstSnapshotDate = firstSnapshotDateTime;
  let secondSnapshotDate = secondSnapshotDateTime;

  if (firstSnapshotDate > secondSnapshotDate) {
    firstSnapshotDate = secondSnapshotDateTime;
    secondSnapshotDate = firstSnapshotDateTime;
  }

  return POST('entra-id/compare', {
    sourceIds,
    selectedIds,
    objectType,
    firstSnapshotDateTime: firstSnapshotDate,
    secondSnapshotDateTime: secondSnapshotDate
  });
}

export {
  listSnapshots,
  createBackup,
  exportSnapshot,
  connectSetup,
  restoreSnapshot,
  compareSnapshot,
}
